import React from 'react';

import {
  HeaderRow,
  TitleContainer,
  SubTitle,
  Title,
} from '../../../components/v2/Header';

import AvilabilityCalendar from './components/AvilabilityCalendar';
import {
  Container,
} from './styles';
import texts from './texts.json';

const ISAvailability = () => (
  <Container>
    <HeaderRow>
      <TitleContainer>
        <Title>{texts.title}</Title>
        <SubTitle>{texts.subTitle}</SubTitle>
      </TitleContainer>
    </HeaderRow>
    <AvilabilityCalendar />
  </Container>
);

export default ISAvailability;
